export const cases = [
  {
    id: 'su-lu-lian-ai',
    title: '苏晚宁 × 陆则言 恋情疑云',
    subtitle: '同一顶帽子、同一只猫，同框照被扒了三层',
    category: '情感关系',
    categoryId: 'gan-qing',
    heat: 96,
    views: '128万',
    date: '2026-09-12',
    readTime: '7 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20abstract%20illustration%20of%20two%20silhouettes%20connected%20by%20threads%2C%20warm%20coral%20and%20green%20palette%2C%20soft%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=760&seq=case-sulu-cover&orientation=landscape',
    summary:
      '一条同款帽子动态、一张背景里同款花纹的猫爬架，把苏晚宁和陆则言推上了热搜。粉丝整理出两人近三个月的时间线，重合的城市、重合的取景地、重合的配饰被逐条标出。争论的核心在于：这到底是巧合、是同一团队的通告安排，还是真有其事？',
    tags: ['恋情疑云', '同款细节', '时间线复盘'],
    personIds: ['su-wanning', 'lu-zeyan', 'tang-ning', 'bai-lu'],
    relations: [
      { from: 'su-wanning', to: 'lu-zeyan', label: '疑似交往', tone: 'primary' },
      { from: 'lu-zeyan', to: 'tang-ning', label: '前经纪人', tone: 'secondary' },
      { from: 'su-wanning', to: 'tang-ning', label: '现合作方', tone: 'secondary' },
      { from: 'lu-zeyan', to: 'bai-lu', label: '同品牌拍摄', tone: 'foreground' },
    ],
    chain: [
      { date: '08-02', title: '同款帽子动态', desc: '陆则言发布日常动态，背景中的帽子被指与苏晚宁机场造型同款，成为第一处"证据"。' },
      { date: '08-19', title: '同城市行程重合', desc: '两人近期通告都落在同一座城市，粉丝开始整理重叠的行程日历。' },
      { date: '09-05', title: '同款猫爬架入镜', desc: '苏晚宁一条居家动态里出现的花纹猫爬架，与陆则言直播背景高度相似。' },
      { date: '09-11', title: '话题冲上热搜', desc: '时间线长图被大量转发，"同框证据链"话题登上热搜榜。' },
      { date: '09-12', title: '双方工作室发声', desc: '两方工作室先后回应，均未直接承认，措辞聚焦在"私人行程不便回应"。' },
    ],
    responses: [
      {
        personId: 'su-wanning',
        stance: '澄清',
        content: '谢谢大家关心私人生活，目前更希望大家把注意力放在即将开播的作品上，其余不多做回应。',
        source: '工作室声明',
        date: '2026-09-12',
      },
      {
        personId: 'lu-zeyan',
        stance: '否认',
        content: '同款单品在行业内很常见，很多是品牌统一提供，希望大家理性看待，不要过度联想。',
        source: '直播回应',
        date: '2026-09-12',
      },
      {
        personId: 'tang-ning',
        stance: '未回应',
        content: '作为合作方，我只负责工作对接，艺人私事不方便替他们回答。',
        source: '媒体采访',
        date: '2026-09-13',
      },
    ],
    faqs: [
      { q: '苏晚宁和陆则言传闻的起点是什么？', a: '最早被注意到的是陆则言一条日常动态里的同款帽子，之后粉丝又发现两人行程城市重合，讨论逐渐升温。' },
      { q: '双方是否正面回应过这段关系？', a: '两方工作室在话题登上热搜后先后发声，但都未直接承认或否认，只表示私人行程不便回应。' },
    ],
  },
  {
    id: 'xing-he-jie-yue',
    title: '陆则言与星河唱片解约风波',
    subtitle: '从"还在谈"到互相发函，只隔了十一天',
    category: '合约风波',
    categoryId: 'he-yue',
    heat: 89,
    views: '96万',
    date: '2026-09-08',
    readTime: '6 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20a%20torn%20contract%20paper%20shape%20with%20warm%20amber%20and%20cream%20palette%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=760&seq=case-jieyue-cover&orientation=landscape',
    summary:
      '陆则言与老东家星河唱片的续约谈判，从"双方仍在沟通"迅速滑向"各自发出律师函"。争议焦点集中在两份合约的时间重叠、创作自主权，以及一笔未结清的版税。谁先违约、谁在拖延，成了这场风波里最难理清的一环。',
    tags: ['合约重叠', '版税争议', '合作关系'],
    personIds: ['lu-zeyan', 'tang-ning', 'gu-zhao', 'shen-yan'],
    relations: [
      { from: 'lu-zeyan', to: 'tang-ning', label: '现任代理', tone: 'primary' },
      { from: 'tang-ning', to: 'gu-zhao', label: '前同事', tone: 'foreground' },
      { from: 'gu-zhao', to: 'lu-zeyan', label: '唱片方代表', tone: 'secondary' },
      { from: 'lu-zeyan', to: 'shen-yan', label: '新歌合作', tone: 'accent' },
    ],
    chain: [
      { date: '07-28', title: '续约谈判启动', desc: '星河唱片发布简短说明，称与陆则言的续约"仍在友好沟通中"。' },
      { date: '08-06', title: '版税结算分歧', desc: '有消息称双方对一笔跨年度版税的计算口径存在分歧，谈判陷入停滞。' },
      { date: '08-13', title: '新歌合作曝光', desc: '陆则言被曝与新团队合作录制单曲，外界猜测其去意已决。' },
      { date: '08-18', title: '首份律师函', desc: '唱片方发出律师函，要求就合约义务进行说明，风波正式公开化。' },
      { date: '08-24', title: '双方各自发声', desc: '陆则言一方回应称从未违约，双方各执一词，事件进入拉锯阶段。' },
    ],
    responses: [
      {
        personId: 'lu-zeyan',
        stance: '否认',
        content: '合约范围内的事我一直在配合，所谓"违约"的说法与事实不符，后续交由法律程序处理。',
        source: '个人声明',
        date: '2026-08-24',
      },
      {
        personId: 'gu-zhao',
        stance: '律师函',
        content: '我们尊重每一位合作者，但也需要通过正式渠道明确合约边界，这不是针对个人。',
        source: '公司声明',
        date: '2026-08-18',
      },
      {
        personId: 'tang-ning',
        stance: '澄清',
        content: '我接手的是商务层面的事务，合约本身的历史问题需要公司之间去核，不是我一个人能说明白的。',
        source: '媒体采访',
        date: '2026-08-22',
      },
    ],
    faqs: [
      { q: '解约风波的核心争议是什么？', a: '主要集中在两份合约的时间重叠、创作自主权归属，以及一笔未结清版税的结算口径。' },
      { q: '目前进展到哪一步？', a: '双方各自发出过声明与律师函，仍处于各执一词的拉锯阶段，最终结果需以法律程序为准。' },
    ],
  },
  {
    id: 'chang-ye-san-ren',
    title: '《长夜微光》剧组三人关系',
    subtitle: '戏里戏外，谁和谁才是真正的"同框"',
    category: '合作纠纷',
    categoryId: 'he-zuo',
    heat: 82,
    views: '77万',
    date: '2026-09-03',
    readTime: '8 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20three%20overlapping%20circles%20shape%20with%20warm%20coral%20and%20green%20palette%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=760&seq=case-changye-cover&orientation=landscape',
    summary:
      '《长夜微光》开播后，导演江屿、主演韩朔与林知遥三人之间的关系被反复解读。有人从杀青照的站位看出端倪，有人从宣传期采访的措辞里找线索。到底是正常的剧组分工带来的误会，还是确有一场关于番位与戏份的角力？',
    tags: ['剧组关系', '番位讨论', '戏份争议'],
    personIds: ['jiang-yu', 'han-shuo', 'lin-zhiyao', 'shen-yan'],
    relations: [
      { from: 'jiang-yu', to: 'han-shuo', label: '导演 × 男主', tone: 'primary' },
      { from: 'jiang-yu', to: 'lin-zhiyao', label: '导演 × 女主', tone: 'primary' },
      { from: 'han-shuo', to: 'lin-zhiyao', label: '同剧搭档', tone: 'accent' },
      { from: 'shen-yan', to: 'jiang-yu', label: '编剧 × 导演', tone: 'secondary' },
    ],
    chain: [
      { date: '07-10', title: '杀青照引猜测', desc: '剧组杀青合影的站位被网友逐帧分析，"谁站中间"成为第一波讨论。' },
      { date: '07-22', title: '采访措辞被解读', desc: '宣传期采访中，韩朔一句"戏份上有过沟通"被解读为对番位的不满。' },
      { date: '08-01', title: '编剧卷入讨论', desc: '编剧沈砚发文谈"改编的取舍"，被部分网友对号入座到演员戏份上。' },
      { date: '08-15', title: '导演正面回应', desc: '江屿在路演中强调群像表达，回应"没有谁被削减，只有叙事需要"。' },
    ],
    responses: [
      {
        personId: 'jiang-yu',
        stance: '澄清',
        content: '群像戏本来就很难平均分配，我做的是让每个角色成立，戏份多少不是衡量尊重的唯一标准。',
        source: '路演现场',
        date: '2026-08-15',
      },
      {
        personId: 'han-shuo',
        stance: '否认',
        content: '我说"沟通过"是指表演层面的讨论，不是对番位有意见，大家可能理解偏了。',
        source: '个人社交动态',
        date: '2026-08-02',
      },
      {
        personId: 'lin-zhiyao',
        stance: '未回应',
        content: '专注作品本身，其他话题就不参与了。',
        source: '工作室转发',
        date: '2026-08-16',
      },
    ],
    faqs: [
      { q: '三人关系的讨论从哪来的？', a: '起因是杀青合影的站位被网友分析，随后宣传期采访的措辞被进一步解读。' },
      { q: '剧组是否回应过番位争议？', a: '导演江屿在路演中正面回应过，强调群像叙事需要，并非针对某位演员。' },
    ],
  },
  {
    id: 'gu-zhao-dai-yan',
    title: '顾昭代言替换疑云',
    subtitle: '一张官宣图的两个版本，把中间人推到了台前',
    category: '商务代言',
    categoryId: 'dai-yan',
    heat: 74,
    views: '58万',
    date: '2026-08-29',
    readTime: '5 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20two%20framed%20photo%20shapes%20side%20by%20side%20with%20warm%20amber%20and%20cream%20palette%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=760&seq=case-daiyan-cover&orientation=landscape',
    summary:
      '某品牌官宣合作时先后放出两版物料，两位主角分别指向白露与苏晚宁，中间只隔了不到一天。替换的原因无人说明，但作为项目操盘手的顾昭被推到了台前。这究竟是排期调整，还是合作对象的一次临时换人？',
    tags: ['代言替换', '物料调整', '商务排期'],
    personIds: ['gu-zhao', 'bai-lu', 'su-wanning', 'tang-ning'],
    relations: [
      { from: 'gu-zhao', to: 'bai-lu', label: '项目合作', tone: 'primary' },
      { from: 'gu-zhao', to: 'su-wanning', label: '后期接洽', tone: 'accent' },
      { from: 'tang-ning', to: 'gu-zhao', label: '对接方', tone: 'secondary' },
      { from: 'bai-lu', to: 'su-wanning', label: '同品牌先后', tone: 'foreground' },
    ],
    chain: [
      { date: '08-20', title: '首版物料发布', desc: '品牌放出第一版合作海报，主角为白露，物料存活不到一天。' },
      { date: '08-21', title: '物料被替换', desc: '同一位置的宣传图被换成另一位主角，网友截图对比引发讨论。' },
      { date: '08-24', title: '经纪人出面', desc: '唐宁在采访中承认"排期有调整"，但未说明具体原因。' },
      { date: '08-27', title: '顾昭回应', desc: '顾昭称属于正常的档期适配问题，与个人评价无关。' },
    ],
    responses: [
      {
        personId: 'gu-zhao',
        stance: '澄清',
        content: '品牌合作看的是档期和调性匹配，这次是排期冲突导致的正常调整，不针对任何人。',
        source: '媒体沟通会',
        date: '2026-08-27',
      },
      {
        personId: 'tang-ning',
        stance: '澄清',
        content: '排期确实动过，我们和品牌方是友好协商的结果，没有所谓的"被换掉"。',
        source: '媒体采访',
        date: '2026-08-24',
      },
      {
        personId: 'bai-lu',
        stance: '未回应',
        content: '（暂无公开回应）',
        source: '—',
        date: '2026-08-29',
      },
    ],
    faqs: [
      { q: '"替换疑云"的关键证据是什么？', a: '品牌在不到一天内先后放出两版官宣物料，主角从一位换为另一位，对比截图被广泛传播。' },
      { q: '操盘方如何解释？', a: '项目操盘手顾昭称属于档期适配的正常调整，合作方经纪人唐宁也确认排期确实调整过。' },
    ],
  },
  {
    id: 'wen-zhi-xia-jian-ji',
    title: '温知夏直播剪辑争议',
    subtitle: '一段被剪掉的三秒，衍生出五种解读',
    category: '言论争议',
    categoryId: 'yan-lun',
    heat: 68,
    views: '43万',
    date: '2026-08-22',
    readTime: '5 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20abstract%20illustration%20of%20a%20film%20strip%20with%20a%20missing%20frame%2C%20warm%20green%20and%20cream%20palette%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=760&seq=case-jianji-cover&orientation=landscape',
    summary:
      '温知夏在一场直播中的一句话被二次剪辑后广泛传播，不同版本之间的差异只有三秒，却足以改变整句话的语气。她本人随后放出完整录像澄清，但关于"剪辑是否失真"的讨论仍在继续，也让直播回放的透明度成为新的关注点。',
    tags: ['剪辑争议', '完整录像', '语境失真'],
    personIds: ['wen-zhixia', 'jiang-yu', 'tang-ning', 'lin-zhiyao'],
    relations: [
      { from: 'wen-zhixia', to: 'jiang-yu', label: '同场嘉宾', tone: 'primary' },
      { from: 'wen-zhixia', to: 'tang-ning', label: '经纪对接', tone: 'secondary' },
      { from: 'lin-zhiyao', to: 'wen-zhixia', label: '节目同台', tone: 'accent' },
      { from: 'jiang-yu', to: 'tang-ning', label: '合作方', tone: 'foreground' },
    ],
    chain: [
      { date: '08-15', title: '直播片段流出', desc: '一段几秒的剪辑视频开始传播，标题带有明显情绪引导。' },
      { date: '08-17', title: '二次剪辑扩散', desc: '不同账号放出多个版本，三秒的删减让语义大相径庭。' },
      { date: '08-19', title: '完整录像发布', desc: '温知夏放出全程回放，指出被删减部分正是语境的关键。' },
      { date: '08-21', title: '同场嘉宾发声', desc: '江屿转发完整录像，表示"现场氛围和剪辑出来的完全不是一回事"。' },
    ],
    responses: [
      {
        personId: 'wen-zhixia',
        stance: '澄清',
        content: '我把完整回放放在这里，前后三秒被剪掉之后意思全变了，大家自己看会更有判断。',
        source: '个人社交动态',
        date: '2026-08-19',
      },
      {
        personId: 'jiang-yu',
        stance: '澄清',
        content: '我就在现场，当时的语境和剪辑出来的效果差很远，希望大家看完整版本再说。',
        source: '转发附言',
        date: '2026-08-21',
      },
      {
        personId: 'tang-ning',
        stance: '未回应',
        content: '（暂无公开回应）',
        source: '—',
        date: '2026-08-22',
      },
    ],
    faqs: [
      { q: '这场争议的起因是什么？', a: '一段经过二次剪辑的直播片段被传播，删减的三秒使整句话的语气发生了明显改变。' },
      { q: '当事人是如何处理的？', a: '温知夏放出全程回放进行澄清，同场嘉宾江屿也转发佐证现场语境。' },
    ],
  },
] as const;